const types = {
  quote: 'QuoteSlice',
  faq_section: 'FaqSection',
  sensor_list: 'SensorListSlice',
  icon_list: 'IconListSlice',
  bottom_banner: 'BottomBanner',
  richtext: 'RichTextSlice',
  quinconce_block: 'QuinconceSlice',
  highlight_block: 'HighlightBlockSlice',
  table: 'TableSlice',
  trustpilot_carousel: 'TrustpilotCarousel',
  trustpilot_carousel_2: 'TrustpilotCarousel2',
  bundle_product: 'BundleProductSlice',
  hero: 'Hero',
  new_hero: 'Hero',
  blue_hero: 'BlueHero',
  horizontal_list: 'HorizontalListSlice',
  vimeo_section: 'VimeoSection',
  article_list: 'ArticlesList',
  scrollable_list: 'ScrollableList',
  card_slice: 'CardSlice',
  article_anchor: 'ArticleSlice',
  simple_section: 'SimpleSection',
  text_icon_section: 'TextIconSection',
  cta_section: 'ButtonSlice',
  video_list: 'VideoCarrousel',
  contact_section: 'ContactSection',
  sub_hero_banner: 'SubHeroBanner',
  process_arrow_block: 'ProcessArrowBlock',
  media_carrousel: 'MediaCarrousel',
  options: 'Options',
  app_block: 'AppBlock',
  giveback_schema: 'GivebackSchema',
  giveback_schema2: 'GivebackSchema2',
  embed_calendly: 'EmbedCalendly',
  hero_full_image: 'HeroFullImage',
  highlight_section: 'HighlightSection', // shared-slice
  highlight_icons: 'HighlightIcons', // shared-slice
  simple_slice: 'SimpleSlice', // shared-slice
  process_arrow: 'ProcessArrow', // shared-slice
  simple_cta: 'SimpleCta', // shared-slice
  faq_slice: 'FaqSlice', // shared-slice
}

const findComponentByType = (type) => types[type] || console.debug(`${type} is not supported yet`)

export { findComponentByType }
